var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { staticClass: "row mx-0" }, [
        _c("div", { staticClass: "col-md-7 py-3" }, [
          _c("div", { staticClass: "d-flex flex-column pr-md-4" }, [
            _c(
              "div",
              {
                staticClass:
                  "info-row d-flex justify-content-between border-bottom py-1"
              },
              [
                _c("span", { staticClass: "text-muted" }, [
                  _vm._v(_vm._s(_vm.$t("txtDuty")))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "font-weight-bold text-right" }, [
                  _vm._v(_vm._s(_vm.duty.title || "NA"))
                ])
              ]
            ),
            _vm._v(" "),
            _vm.activity.title
              ? _c(
                  "div",
                  {
                    staticClass:
                      "info-row d-flex justify-content-between border-bottom py-1"
                  },
                  [
                    _c("span", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(_vm.$t("txtActivityTitle")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "font-weight-bold text-right" }, [
                      _vm._v(_vm._s(_vm.activity.title))
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activity.cellName
              ? _c(
                  "div",
                  {
                    staticClass:
                      "info-row d-flex justify-content-between border-bottom py-1"
                  },
                  [
                    _c("span", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(_vm.$t("txtCellName")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "font-weight-bold text-right" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              _vm.baseUrl + "quick?cell=" + _vm.activity.cellId
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.activity.cellName) +
                              "\n              "
                          )
                        ]
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activity.cellName
              ? _c(
                  "div",
                  {
                    staticClass:
                      "info-row d-flex justify-content-between border-bottom py-1"
                  },
                  [
                    _c("span", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(_vm.$t("activityCellPath")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-right small" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            [..._vm.activity.cellParents]
                              .concat(_vm.activity.cellName)
                              .join(" > ")
                          ) +
                          "\n            "
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activity.cellName
              ? _c(
                  "div",
                  {
                    staticClass:
                      "info-row d-flex justify-content-between border-bottom py-1"
                  },
                  [
                    _c("span", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(_vm.$t("activity.cell.risk")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "font-weight-bold text-right" }, [
                      _vm._v(_vm._s(_vm.activity.cellRisk))
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "info-row d-flex justify-content-between border-bottom py-1"
              },
              [
                _c("span", { staticClass: "text-muted" }, [
                  _vm._v(_vm._s(_vm.$t("txtActivityReference")))
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "font-weight-bold text-right" },
                  [
                    _vm.activity.reference
                      ? [_vm._v(_vm._s(_vm.activity.reference))]
                      : [
                          _c(
                            "span",
                            { staticClass: "text-primary font-weight-normal" },
                            [_vm._v(" " + _vm._s(_vm.$t("txtEmpty")))]
                          )
                        ],
                    _vm._v(" "),
                    _c("i", {
                      staticClass:
                        "fas fa-pencil-alt ml-2 text-silver c-pointer small",
                      attrs: {
                        "data-toggle": "modal",
                        "data-target": "#referenceeditmodal"
                      }
                    })
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _vm.activity.fkUserResponsibleName
              ? _c(
                  "div",
                  {
                    staticClass:
                      "info-row d-flex justify-content-between border-bottom py-1"
                  },
                  [
                    _c("span", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(_vm.$t("txtResponsibles")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "font-weight-bold text-right" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.activity.fkUserResponsibleName) +
                          "\n              \n\t\t\t\t\t\t\t"
                      ),
                      _vm.canSetResponsiblePerson
                        ? _c("i", {
                            staticClass:
                              "fas fa-pencil-alt ml-2 text-silver c-pointer small",
                            attrs: {
                              "data-toggle": "modal",
                              "data-target": "#userselectmodal"
                            }
                          })
                        : _vm._e()
                    ])
                  ]
                )
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-5 py-3 bg-white" }, [
          _c(
            "div",
            { staticClass: "info-row d-flex justify-content-between py-2" },
            [
              _c("span", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.$t("activityPrio")))
              ]),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "font-weight-bold text-right" },
                [
                  _vm.activity.priority
                    ? [
                        _c(
                          "span",
                          {
                            staticClass: "badge",
                            style: _vm.priorityBadgeStyle
                          },
                          [_vm._v(_vm._s(_vm.activity.priority.name))]
                        )
                      ]
                    : [
                        _c("span", { staticClass: "text-muted small" }, [
                          _vm._v(_vm._s(_vm.$t("activityNoPrio")))
                        ])
                      ],
                  _vm._v(" "),
                  _c("i", {
                    staticClass:
                      "fas fa-pencil-alt ml-2 text-silver c-pointer small",
                    attrs: {
                      "data-toggle": "modal",
                      "data-target": "#prioselectmodal"
                    }
                  })
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass:
                "font-weight-bold text-muted small text-uppercase mb-2 d-block"
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("activityDescription")) +
                  "\n          \n\t\t\t\t\t"
              ),
              _c("i", {
                staticClass:
                  "fas fa-pencil-alt c-pointer ml-1 text-silver small",
                attrs: {
                  "data-toggle": "modal",
                  "data-target": "#descriptioneditmodal"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "p-3 rounded border",
              class: { "bg-light border-dashed": !_vm.activity.description },
              staticStyle: { "min-height": "200px", cursor: "pointer" },
              attrs: {
                "data-toggle": "modal",
                "data-target": "#descriptioneditmodal"
              }
            },
            [
              _vm.activity.description
                ? _c(
                    "p",
                    {
                      staticClass: "text-break mb-0",
                      staticStyle: { "white-space": "pre-line" }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.activity.description) +
                          "\n          "
                      )
                    ]
                  )
                : _c("div", { staticClass: "text-center mt-4" }, [
                    _c("i", {
                      staticClass: "fas fa-align-left text-muted mb-2 d-block",
                      staticStyle: { "font-size": "1.2rem" }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "text-muted font-italic small" },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t("btnEdit") ||
                                "Klicken Sie hier, um eine Beschreibung hinzuzufügen..."
                            ) +
                            "\n            "
                        )
                      ]
                    )
                  ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mx-0 border-top mt-1 pt-0" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("ImageViewer", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activity.file && _vm.activity.file.length,
                  expression: "activity.file && activity.file.length"
                }
              ],
              attrs: { medias: _vm.activity.file }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-1" },
              [
                _c("DropZone", {
                  staticClass: "w-100",
                  attrs: { formId: "activityedit" + _vm._uid },
                  on: { complete: _vm.onDzComplete }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("UserSelectModal", {
        attrs: {
          modalId: "userselectmodal",
          available: _vm.availableResponsibles,
          selected: _vm.selectedResponsible
        },
        on: { selected: _vm.responsibleChanged }
      }),
      _vm._v(" "),
      _c("ReferenceEditModal", {
        ref: "referenceeditmodal",
        attrs: {
          modalId: "referenceeditmodal",
          reference: _vm.activity.reference
        },
        on: { saved: _vm.referenceSaved }
      }),
      _vm._v(" "),
      _c("PrioritySelectModal", {
        attrs: {
          modalId: "prioselectmodal",
          available: _vm.availablePriorities,
          selected: _vm.activity.priority
        },
        on: { selected: _vm.priorityChanged }
      }),
      _vm._v(" "),
      _c("DescriptionEditModal", {
        ref: "descriptioneditmodal",
        attrs: {
          modalId: "descriptioneditmodal",
          description: _vm.activity.description
        },
        on: { saved: _vm.descriptionSaved }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }